import { FormInput } from '../../../../../../../components/form';
import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { BankAccountModel } from '../../constants';

const IBANModelFields = () => {
    const { t } = useTranslation();

    return (
        <>
            <FormInput
                name="iban"
                label={t('sauron.financeModule.bankAccounts.drawer.fields.iban.label')}
                placeholder={t('sauron.financeModule.bankAccounts.drawer.fields.iban.placeholder')}
                required
            />
            <FormInput
                name="bic"
                label={t('sauron.financeModule.bankAccounts.drawer.fields.bic.label')}
                placeholder={t('sauron.financeModule.bankAccounts.drawer.fields.bic.placeholder')}
                required
            />
        </>
    );
};

const CLABEModelFields = () => {
    const { t } = useTranslation();

    return (
        <>
            <FormInput
                name="clabe"
                label={t('sauron.financeModule.bankAccounts.drawer.fields.clabe.label')}
                placeholder={t('sauron.financeModule.bankAccounts.drawer.fields.clabe.placeholder')}
                required
            />
            <FormInput
                name="bankName"
                label={t('sauron.financeModule.bankAccounts.drawer.fields.bankName.label')}
                placeholder={t('sauron.financeModule.bankAccounts.drawer.fields.bankName.placeholder')}
                required
            />
        </>
    );
};

export const BankAccountModelFields = ({ model }) => {
    if (!model) {
        return null;
    }

    switch (model) {
        case BankAccountModel.IBAN:
            return <IBANModelFields />;
        case BankAccountModel.CLABE:
            return <CLABEModelFields />;
        default:
            return null;
    }
};

BankAccountModelFields.propTypes = {
    model: PropTypes.string
};
